/**
 * Formatting helpers for user-facing values.
 */

/**
 * Pick the Russian plural form of "балл" for the given amount.
 *
 * Uses the integer part of the value to choose between
 * "балл" / "балла" / "баллов".
 */
export const pluralizeBalls = (value: number): string => {
  const n = Math.abs(Math.trunc(value)) % 100;
  const n10 = n % 10;
  if (n > 10 && n < 20) return 'баллов';
  if (n10 === 1) return 'балл';
  if (n10 >= 2 && n10 <= 4) return 'балла';
  return 'баллов';
};

/**
 * Format a ball balance for display with a localized number and the
 * correctly declined "балл" unit. Fractional balances keep two decimals.
 */
export const formatBalls = (value: number): string => {
  const isWhole = Number.isInteger(value);
  const formatted = value.toLocaleString('ru-RU', {
    minimumFractionDigits: isWhole ? 0 : 2,
    maximumFractionDigits: 2,
  });
  return `${formatted} ${pluralizeBalls(value)}`;
};
